import * as React from 'react';
import { History } from 'history';
import Model from './quizanswer-model';
import BasePicklistCard from '../base/base-picklistcard.component';
import { align } from '../../services/app.service';

interface IProps {
  history: History
  questionId: number;
  caption?: string;
  currentId?: number;
  onLoad?: (data: any) => void;
  readOnly?: boolean;
  cardCount?: number;
  cardBorderRadius?: number;
  cardAlign?: align;
  swipe?: string;
}

interface IState {
}

export default class QuizanswerPicklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <BasePicklistCard history={this.props.history} caption={this.props.caption} endPointFilter={Model.endPointFilter+this.props.questionId} model={Model} currentId={this.props.currentId} onLoad={this.props.onLoad} readOnly={this.props.readOnly} cardCount={this.props.cardCount} cardBorderRadius={this.props.cardBorderRadius} cardAlign={this.props.cardAlign} swipe={this.props.swipe} disableBackButton disableCard/>
    );
  }
}
